import { adjustDecimalNumber } from '../tools';

/**
 * @url https://agirpourlatransition.ademe.fr/particuliers/calculer-emissions-carbone-trajets
 * L'avion est proposé à partir de 500 km, avec les tailles suivantes :
 *
 * 500 à 1 000 km, 101 à 220 sièges : 126 gCO2e/km/personne sans l'impact des traînées, 230 gCO2e/km/personne avec l'impact des traînées
 *  1 000 à 2 000 km, 101 à 220 sièges : 102 gCO2e/km/personne sans l'impact des traînées, 186 gCO2e/km/personne avec l'impact des traînées
 *   2 000 à 3 500 km, >220 sièges : 97,4 gCO2e/km/personne sans l'impact des traînées, 178 gCO2e/km/personne avec l'impact des traînées
 * au delà de 3 500 km, >220 sièges : 82,8 gCO2e/km/personne sans l'impact des traînées, 151 gCO2e/km/personne avec l'impact des traînées
 *
 * @param {integer} co2 in kilogram
 */
const kgToPlane = (co2) => {
    /**
     * complete is with the airplane vapour trail
     */
    const config = [
        { min: 500, max: 1000, base: 0.126, complete: 0.23 },
        { min: 1000, max: 2000, base: 0.102, complete: 0.186 },
        { min: 2000, max: 3000, base: 0.974, complete: 0.178 },
        { min: 3000, max: null, base: 0.828, complete: 0.151 },
    ];
    let kmProgressive = 0;

    for (let i = 0; i < config.length; i++) {
        let result = co2 / config[i].complete;

        if (config[i].max === null || result < config[i].max) {
            kmProgressive = result;
            break;
        }
    }

    return {
        value: adjustDecimalNumber(kmProgressive),
        unity: `kms`,
        type: `plane`,
    };
};

/**
 * 193 gCO2e/km/véhicule ;
 * Base Carbone ADEME, moyenne nationale toutes distances, toutes carburations.
 * Les données intègrent l’amont et la combustion du carburant.
 * Comme pour les autres modes de transports, elles n’intègrent pas la
 * fabrication des véhicules et
 * les émissions liées aux infrastructures routières.
 * @param {*} co2
 */
const kgToCar = (co2) => {
    const baseCar = 0.193;
    const kmOfCar = adjustDecimalNumber(co2 / baseCar);

    return {
        value: kmOfCar,
        unity: `kms`,
        type: `car`,
    };
};

/**
 * 61,6 g
 * @param {integer} co2
 */
const kgToScooter = (co2) => {
    const baseScooter = 0.0616;
    const kmOfScooter = adjustDecimalNumber(co2 / baseScooter);

    return {
        value: kmOfScooter,
        unity: `kms`,
        type: `scooter`,
    };
};

/**
 * Allow to dispatch the great method depending on the amount of kg
 * @param {integer} value
 */
const dispatchFromKg = (value) => {
    return value < 50
        ? kgToScooter(value)
        : value < 100
        ? kgToCar(value)
        : kgToPlane(value);
};

export { kgToPlane, kgToScooter, kgToCar, dispatchFromKg };
